import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

import { config as productConfig } from '@/src/config';
/**
 * Utility function to merge Tailwind CSS classes
 * Combines clsx and tailwind-merge for optimal class handling
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Get the API base URL - always use full URL for Tauri desktop app compatibility
 * This works for both Vercel web (direct API call) and Tauri (no proxy available)
 */
export function getApiBaseUrl(): string {
  // On dev.weavein.ai, use relative URLs so Vercel proxy rewrites handle routing (avoids CORS)
  if (typeof window !== 'undefined' && window.location.hostname === 'dev.weavein.ai') return '';
  return (productConfig.weaveinApi.baseUrl ?? 'https://weavein-api.onrender.com').trim();
}

/**
 * Build a full API URL from a path
 * @param path - API path starting with /api/...
 * @returns Full URL with base URL prepended
 */
export function buildApiUrl(path: string): string {
  const baseUrl = getApiBaseUrl();
  // Ensure path starts with /
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${cleanPath}`;
}
